import './src/pages/styles/_styles.scss'